<template>
  <v-card class="h-100">
    <app-header></app-header>
    <div :class="isLogin ? 'mt-70' : ''"></div>
    <v-container grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 md7 lg10 class="col-height-auto">
          <div class="font-30 fw-700 mb-5 text-center">Corporate GDPR Statement</div>
          <div class="font-16 fw-400">
            <p>
              In May 2018, the EU
              <a class="primary--text"
                href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679" target="_blank"
              >General Data Protection Regulation (GDPR)</a>
              replaces the existing 1995 EU Data Protection Directive (European Directive 95/46/EC).
            </p>

            <p>
              IOB LLC currently complies with applicable data protection regulations and is committed to GDPR compliance across its relevant services when the GDPR
              takes effect May 25, 2018. IOB LLC has a dedicated internal team made up of cross-functional stakeholders overseeing IOB LLC’s GDPR readiness. IOB LLC’s
              ongoing compliance efforts include:
            </p>

            <h4>
              <strong>Assessment</strong>
            </h4>

            <p>
              IOB LLC has reviewed where and how our relevant services collect, use, store and dispose of personal data and has updated policies, standards,
              governance and documentation where needed. IOB LLC is dedicated to keeping such due diligence current and carrying out re-assessments periodically
              and/or as required by changed circumstances.
            </p>

            <h4>
              <strong>Contractual Commitments</strong>
            </h4>

            <p>
              Working in conjunction with our partners and customers, IOB LLC is reviewing our contractual commitments and updating as needed to directly address GDPR
              requirements. IOB LLC has released a Data Processing Addendum (DPA) with provisions to assist our partners and customers with their GDPR compliance.
            </p>

            <h4>
              <strong>Cross-border Data Transfer</strong>
            </h4>

            <p>
              In addition to ensuring IOB LLC’s contractual commitments meet the requirements to legally transfer data from the EU to the rest of the world under
              applicable law, IOB LLC plans to certify under the EU-US Privacy Shield Framework.
            </p>

            <h4>
              <strong>Employee Training And Awareness</strong>
            </h4>

            <p>
              All IOB LLC employees must complete data privacy and security training. IOB LLC will supplement existing training modules with GDPR-specific content. In
              addition to these training requirements, IOB LLC conducts ongoing awareness initiatives on a variety of topics, including data protection, security
            </p>

            <h4>
              <strong>IOB LLC Investors, Partners, and Customers</strong>
            </h4>

            <p>
              Compliance with the GDPR requires a partnership between IOB LLC and our partners and customers in their use of applicable IOB LLC services. In this
              context, IOB LLC generally will act as a data processor and our partners and customers generally will act as data controllers. Working together, we hope
              to explore opportunities within our relevant service offerings to assist our partners and customers meet their GDPR obligations. In the meantime, IOB
              LLC encourages partners and customers to independently familiarize themselves with the GDPR.
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Vue from "vue";
import config from "../../config.js";
export default {
  data() {
    return {};
  },
  computed: {},
  computed: {
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted: function() {},
  watch: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// GDPR.vue?4232701b